module.exports = __webpack_public_path__ + "static/media/chess-book-main.60997fc8.png";